<div class="searchBg">
  <input type="text" class="form-control pr-5" [ngClass]="Classes" id="What" name="What" placeholder="{{Placeholder}}"
    [(ngModel)]="SearchKeywordTitle" (input)="OnInputRecentSearch($event)" (keydown)="OnkeyDownSearch($event)"
    (click)="DisplayRecentSearches($event)" (keyup)="OnkeyUpSearch($event)" on-change="OnSearchKeywordChange()"
    (keydown.Tab)="onFocusoutSearch()" autocomplete="off" />
</div>

<div id="savesearchautocomplete" *ngIf="IsSuggestAutoCompleteSearch">
  <!-- Show autocomplete results -->
  <div class="opt">
    <ul class="list-group suggestion-list" *ngIf="DisplaySuggestedSector?.length > 0">
      <li class="list-group-item title not-allowed"><i class="fas fa-business-time"></i> Job
        title or Skill</li>
      <li class="list-group-item" [class.autocompleteactive]="i == ArrowkeySuggestedSearch"
        *ngFor="let childIndustry of DisplaySuggestedSector;let i=index;" id="ChildSectors{{i}}"
        (click)="OnSearchOptionSelected(childIndustry)">
        {{childIndustry.Value}}
        <span class="auto-complete-type"
          *ngIf="childIndustry.DisplayValue != 'Held Position'">{{childIndustry.DisplayValue}}</span>
        <span class="auto-complete-type" *ngIf="childIndustry.DisplayValue == 'Held Position'">Title</span>
      </li>
    </ul>
  </div>
</div>

<div id="savesearchautocomplete" *ngIf="IsSuggestRecentSearch && !HideRecentSearches">
  <!-- Show recent auto searches -->
  <div [ngClass]="{'opt': IsAdvanceSearchPage == false, 'opt-advance': IsAdvanceSearchPage == true}">
    <ul class="list-group" *ngIf="RecentSearchesAutoComplete?.length > 0">
      <li class="list-group-item title not-allowed"><i class="fas fa-history"></i> Recent
        Searches</li>
      <li [class.autocompleteactive]="i == ArrowkeySuggestedRecentSearch" class="list-group-item"
        *ngFor="let recentSearch of RecentSearchesAutoComplete;let i=index;"
        (click)="OnSearchRecentOptionSelected(recentSearch, 'true')">
        <span class="recent-text"> {{recentSearch.DisplayTitle}}</span> <span class="fa fa-angle-right recent-arrow">
        </span>
      </li>
    </ul>
  </div>
</div>
